// 板
import rlModel from "./rlModel";
import store from "@/store/index";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";

class rlSlab extends rlModel {
  constructor() {
    super();
    this.componentType = "slab";
    this.points = []; // 顶点数据
    this.SectData = []; //截面源数据
    this.m_sectParamData = null;
    this.VertexX = null; //楼板轮廓点的 X 坐标
    this.VertexY = null; //楼板轮廓点的 Y 坐标
    this.VertexZ = null; //楼板轮廓点的 Z 坐标
    this.ParaVal = null; //楼层默认厚度
    this.Thickness = null; //楼板厚度,9999 表示同标准层参数

    this.RoomlsHole = 0; //是否全洞
    this.Attribute = 2; //默认为一般构件

    this._threeObj = null; //三维图形对象
    this.Color = "#E1DDDD";
    this.ModelType = "楼板";
    //   (this.rlLayer && this.rlLayer[3] && this.rlLayer[3].storey) || '#00ff66' //构件颜色
    // this.Layer = 'rlSlab' //图层名称
    this.m_gridIds = []; //板关联的网格guid集合--用于pkpm数据导入导出
    this.gridsObjs = []; //板关联的网格对象集合
    this.classTypeName = "rlSlab"; // 板
    this.m_groupName = "rlSlabGroup"; //组名
    this.m_sectGroupName = ""; //截面字符

    // wasm接口方法
    this.getPKPM_SlabData =
      store.state.globalData.rl_wasm_module.getPKPM_SlabData;
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  initData(obj) {
    super.initData(obj);
    this.m_gridIds = obj.GridsID;

    this.VertexX = obj.VertexX;
    this.VertexY = obj.VertexY;
    this.VertexZ = obj.VertexZ;
    this.ParaVal = obj.ParaVal;
    this.Thickness = obj.Thickness;
    this.RoomlsHole = obj.RoomlsHole;
    this.Color = obj.Color ? obj.Color : "#00ff66";
  }
  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridIds = obj.m_gridIds;

    this.VertexX = obj.VertexX;
    this.VertexY = obj.VertexY;
    this.VertexZ = obj.VertexZ;
    this.ParaVal = obj.ParaVal;
    this.Thickness = obj.Thickness;
    this.RoomlsHole = obj.RoomlsHole;
  }
  // 添加
  add(obj) {
    const beamParams = obj.beamParams;
    // this.ID = obj.ID
    this.Guid = obj.Guid;
    this.m_gridIds = beamParams.GridsID;
    this.gridsObjs = obj.gridsObjs;

    this.rlFloorData = obj.rlFloorData;

    this.VertexX = beamParams.VertexX;
    this.VertexY = beamParams.VertexY;
    this.VertexZ = beamParams.VertexZ;
    this.ParaVal = beamParams.ParaVal;
    this.Thickness = beamParams.Thickness;
    this.LevelB = beamParams.LevelB;
    this.Height = Number(beamParams.Height);

    this.m_sectParamData = beamParams.m_sectParamData;

    // this.Color = beamParams.Color ? beamParams.Color : '#00ff66'
    // this.Layer = beamParams.Layer ? beamParams.Layer : 'rlSlab'
    this.Strength = obj.Strength ? obj.Strength : null;
    this.StrengthOther = obj.StrengthOther ? obj.StrengthOther : null;
  }

  // 数据转换
  convert() {
    let res = this.getPKPM_SlabData(
      this.VertexX,
      this.VertexY,
      this.ParaVal,
      this.m_sectParamData.Thickness,
      this.LevelB,
      this.Height
    );

    this.getModelDrawData(JSON.parse(res));
  }

  // wasm截面数据转换
  getModelDrawData(modelData) {
    this.points = modelData.Points;
    this.index3dData = modelData["3D"]["3dFaces"]
      .map((item) => item.index)
      .flat();
    this.index2dData = modelData["2DUpView"];
    this.SectData = modelData["SectData"];
  }

  // 删除
  erase() {
    this.m_gridIds ? (this.m_gridIds = []) : "";
    this.gridsObjs ? (this.gridsObjs = []) : "";
    super.erase();
  }

  async myClone() {
    let newObj = await super.myClone();
    newObj.m_gridIds = this.GridsID;

    newObj.VertexX = this.VertexX;
    newObj.VertexY = this.VertexY;
    newObj.VertexZ = this.VertexZ;
    newObj.ParaVal = this.ParaVal;
    newObj.Thickness = this.Thickness;

    return newObj;
  }

  // 绘制
  worldDraw(pWorldDraw) {
    // let wObj;
    if (!this.member) {
      //非点击构件生成才走数据转换
      this.convert();
    }
    if (pWorldDraw.mxObj._is2d) {
      // wObj = this.create2dModel(this.index2dData);
      // wObj.material.color.set(this.Color);
      pWorldDraw.setColor(new THREE.Color(this.Color));
      this.create2dModel(this.index2dData, pWorldDraw);
    }

    this._threeObj = this.create3dModel(
      this.points,
      this.index3dData,
      0.004,
      3
    );

    this.gridsObjs &&
      this.gridsObjs.forEach((ele) => {
        if (ele && !ele.m_slabIds.includes(this.objectId()))
          ele.m_slabIds.push(this.objectId());
      });

    // pWorldDraw.drawEntity(wObj);
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    this.onDwgIn(obj);
    return true;
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;
    data["GridsGuid"] = this.m_gridIds;
    data["VertexX"] = this.VertexX;
    data["VertexY"] = this.VertexY;
    data["VertexZ"] = this.VertexZ;
    data["RoomIsHole"] = this.RoomIsHole;
    data["Thickness"] = this.m_sectParamData.Thickness;
    data["Shape"] = this.Shape;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["SectGuid"] = this.m_sectParamData.Guid;
    data["GridsGuid"] = this.m_gridIds;
    data["VertexX"] = this.VertexX;
    data["VertexY"] = this.VertexY;
    data["VertexZ"] = this.VertexZ;
    data["RoomIsHole"] = this.RoomIsHole;
    data["Thickness"] = this.m_sectParamData.Thickness;
    data["Shape"] = this.Shape;

    return data;
  }
}

export { rlSlab };
